export const Authorize = async ({ clientId, environment, scope, access_token }) => {
  const lzw = require('json-url')('lzw')

  var headers = new Headers({ 
      'Content-Type': 'application/json',
      'Accept':       'application/json'
    });

  var url;
  var payload;

  switch (environment) {
    case null:
    case "dev":
      url = "https://dev-js.onsched.com/auth";
      // url = "https://localhost:5001/auth";
      break;
    case "sbox":
      url = "https://sandbox-js.onsched.com/auth";
      break;
    case "live":
      url = "https://js.onsched.com/auth";
      break;
    default:
      url = "https://sandbox-js.onsched.com/auth";
      break;
  }

  if (access_token) {
    url += '/mobile';
    payload = { access_token };
  }
  else {
    url += '/initialize';
    payload = { clientId, scope };
  }

  var request = new Request(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'include',
      headers: headers
  });
  const response = await fetch(request);

  // retrieve the clientId
  let sessId = response.headers.get('x-onsched-client-id')

  lzw.compress(sessId).then( result => {
    sessionStorage.setItem('client_sn', result)
  })

  const json = await response.json().catch(function (error) {
      console.log(error);
  });

  if (json.success == false) {
    reject (new Error(json.message));
    // console.log(json.message);
  }

  return json.status === 'ok';
}

export const PostValidateJwt = async (url, payload) => {

  var headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });

  var request = new Request(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'include',
      headers: headers
  });

  const response = await fetch(request);
  const json = await response.json();

  return json;
}

const ShowProgress = () => {
  var indicators = document.getElementsByClassName("onsched-progress");
  for (var i = 0; i < indicators.length; i++) {
      indicators[i].style.display = "block";
  }
}

const HideProgress = () => {
    var indicators = document.getElementsByClassName("onsched-progress");
    for (var i = 0; i < indicators.length; i++) {
        indicators[i].style.display = "none";
    }
}

const getRequestParams = () => {
  var clientTracker = sessionStorage.getItem('client_sn')
  var headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'x-onsched-jspx-sn': clientTracker });
  return { headers, mode: 'cors', credentials: 'include' }
}

const handleAuthErr = response => {
    if (response.status != 401) // for debugging auth errors
        return new Promise((resolve) => response.json().then((json) => resolve({ status: response.status, ok: response.ok, json })));
    else
        return new Promise((resolve) => resolve({ status: response.status, ok: response.ok, json: '' }));
}

const handleBadReq = (props, callback) => {
    const { status, json, ok } = props

    var validation = status == 400;
    ok ? callback(json) : callback({ error: true, code: status, validation, data: json });
    HideProgress();
}

const handleReq = (request, callback) => {
    fetch(request)
        .then(handleAuthErr)
        .then(({ status, json, ok }) => handleBadReq({ status, json, ok }, callback))
        .catch(console.log);
}

const Get = (url, callback) => {
    try {
        let requestParams = getRequestParams();

        requestParams.method = 'GET';
        delete requestParams.body;

        handleReq(new Request(url, requestParams), callback)
    } 
    catch (e) { console.log(e); throw e }
}

const Post = (url, payload, callback) => {
    try {
        let requestParams = getRequestParams();

        requestParams.method = 'POST';
        requestParams.body = JSON.stringify(payload);

        handleReq(new Request(url, requestParams), callback)
    } 
    catch (e) { console.log(e); throw e }
}

const Put = (url, payload, callback) => {
    try {
        let requestParams = getRequestParams();

        requestParams.method = 'PUT';
        requestParams.body = JSON.stringify(payload);

        handleReq(new Request(url, requestParams), callback)
    } 
    catch (e) { console.log(e); throw e }
}

const Delete = (url, callback) => {
    try {
        let requestParams = getRequestParams();
        
        requestParams.method = 'DELETE';
        delete requestParams.body;

        handleReq(new Request(url, requestParams), callback)
    } 
    catch (e) { console.log(e); throw e }
}


export const OnSchedRest = {
  Authorize,
  PostValidateJwt,
  ShowProgress,
  HideProgress,
  Get,
  Post,
  Put,
  Delete
}
